import momentTZ from "moment-timezone";
import { FormattedMessage } from "react-intl";

import { ReactComponent as PickupPackageIcon } from "assets/images/iconsV2/package-up.svg";
import { ReactComponent as DeliveryPackageIcon } from "assets/images/iconsV2/package-right.svg";
import Badge from "components/v2/Badge/Badge";

interface StopInfoProps {
  stop: {
    stop_type?: string;
    stop_time_type?: string;
    stop_after_datetime?: string;
    stop_before_datetime?: string;
    stop_timezone?: string;
    address_details?: {
      city?: string;
      state?: string;
      country?: string;
    };
  };
}

const getRequestedDateTime = (stop: StopInfoProps["stop"]) => {
  let sourceDatetime = stop.stop_after_datetime;

  if (["Before", "Between"].includes(stop.stop_time_type || "")) {
    sourceDatetime = stop.stop_before_datetime || stop.stop_after_datetime;
  }

  if (!sourceDatetime) {
    return "-";
  }

  if (stop.stop_timezone) {
    return momentTZ(sourceDatetime).tz(stop.stop_timezone).format("D MMMM YYYY, HH:mm");
  }

  return momentTZ(sourceDatetime).format("D MMMM YYYY, HH:mm");
};

export default function EditScheduleStopInfo({ stop }: StopInfoProps) {
  const isPickup = stop.stop_type === "Pickup";
  const { city, state, country } = stop.address_details || {};
  const primaryLocation = state || city || "";
  const location = [primaryLocation, country].filter(Boolean).join(", ");

  return (
    <div className="stop-info">
      <div className="mb-2">
        <Badge
          type="status-badge"
          size="sm"
          color={isPickup ? "indigo" : "success"}
          variant="icon-leading"
          label={
            isPickup ? (
              <FormattedMessage id="general.pickup" defaultMessage="Pickup" />
            ) : (
              <FormattedMessage id="general.delivery" defaultMessage="Delivery" />
            )
          }
          icon={isPickup ? <PickupPackageIcon stroke="#6172F3" /> : <DeliveryPackageIcon stroke="#079455" />}
        />
      </div>

      <div className="font-b3 text-secondary">{getRequestedDateTime(stop)}</div>
      <div className="font-b3 text-secondary">{location || "-"}</div>
    </div>
  );
}
